<div class="attr-list-root">
  <!-- Auto-hiding back button -->
  <button type="button" class="attr-back-btn" [class.hidden]="!isBackVisible"
    (click)="back()" [attr.aria-label]="'attractions.backCd' | translate">
    <app-attr-icon name="arrow-back" [size]="20"></app-attr-icon>
  </button>

  <!-- Error -->
  <app-attraction-error-state *ngIf="error && !items.length" [message]="error" (retry)="retry()">
  </app-attraction-error-state>

  <!-- Loading skeleton -->
  <div class="attr-list-skeleton" *ngIf="loading && !items.length && !error">
    <div class="attr-hero-skeleton"></div>
    <div class="attr-card-skeleton" *ngFor="let s of skeletonRows"></div>
  </div>

  <!-- Empty -->
  <div class="attr-empty" *ngIf="!loading && !error && !items.length">
    <p>{{ 'attractions.empty' | translate }}</p>
  </div>

  <!-- Content -->
  <ng-container *ngIf="items.length">
    <!-- Hero. The photo is one specific attraction's, so the overlay names it and tapping anywhere
         opens that attraction. Inert when nothing resolves — no handler and no pointer cursor,
         rather than a tap that does nothing. -->
    <div class="attr-hero" [class.tappable]="heroCode" (click)="onHeroClick()">
      <app-attraction-image class="attr-hero-img" [url]="heroImageUrl" [alt]="heroTitle || city"></app-attraction-image>
      <div class="attr-hero-text">
        <span class="attr-hero-badge">{{ 'attractions.featured' | translate }}</span>
        <h1 class="attr-hero-title">{{ heroTitle }}</h1>
        <span class="attr-hero-cta" *ngIf="heroCode">
          {{ 'attractions.seeDetails' | translate }}
          <app-attr-icon name="chevron-right" [size]="16"></app-attr-icon>
        </span>
      </div>
    </div>

    <!-- Recommended carousel -->
    <ng-container *ngIf="recommended.length">
      <h2 class="attr-section-header">{{ 'attractions.cantMiss' | translate }}</h2>
      <div class="attr-recommended-row">
        <app-attraction-tile *ngFor="let r of recommended; trackBy: trackByCode"
          [attraction]="r" (tileClick)="onOpen($event, 'recommended')">
        </app-attraction-tile>
      </div>
    </ng-container>

    <!-- All attractions -->
    <h2 class="attr-section-header">{{ 'attractions.all' | translate }}</h2>
    <div class="attr-list">
      <app-attraction-card *ngFor="let a of items; trackBy: trackByCode"
        [attraction]="a" (cardClick)="onOpen($event)">
      </app-attraction-card>
    </div>

    <!-- Load-more spinner -->
    <div class="attr-loading-more" *ngIf="loadingMore">
      <div class="attr-spinner"></div>
    </div>
  </ng-container>
</div>
